import { createFileRoute, Link } from "@tanstack/react-router";
import { EditablePageShell, useSitePage } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";
import backyard from "@/assets/lifestyle-backyard.jpg";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/night-golf")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("night-golf")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Night Golf with Glow Long Golf Balls" },
      { name: "description", content: loaderData?.meta_description || "Twilight rounds, glow scrambles, backyard practice — Glow Long balls turn the night into a course." },
      { property: "og:title", content: loaderData?.title || "Night Golf with Glow Long Golf Balls" },
      { property: "og:description", content: loaderData?.meta_description || "Twilight rounds, glow scrambles, backyard practice — Glow Long balls turn the night into a course." },
      { property: "og:url", content: "https://glowlonggolf.com/night-golf" },
      { property: "og:image", content: SHARE_IMAGES.cometSwing },
      { name: "twitter:image", content: SHARE_IMAGES.cometSwing },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/night-golf" }],
  }),

  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: NightGolfPage,
});

function NightGolfPage() {
  const page = useSitePage("night-golf");
  const img = page?.hero_image_url || backyard;
  return (
    <EditablePageShell
      slug="night-golf"
      defaults={{ eyebrow: "Night Golf", title: "Built for play after dark", lead: "Twilight rounds, glow scrambles, par-3 nights, backyard putt-putt — Glow Long shines for all of it." }}
    >
      <section className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-2 lg:px-8">
        <div className="overflow-hidden rounded-3xl border border-border bg-card"><img src={img} alt="Backyard night golf" className="h-full w-full object-cover" loading="lazy" /></div>
        <div className="space-y-4 text-muted-foreground">
          <h2 className="font-display text-2xl font-semibold text-foreground">The night-golf starter kit</h2>
          <p>One 6-pack per 1–2 players, a headlamp each, and a tee marker for the group. That's it.</p>
          <p>For tournaments and corporate scrambles, plan one <Link to="/events" className="text-primary underline">Event Pack</Link> per six players.</p>
          <Link to="/shop" className="inline-flex rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90">Shop the 6-pack</Link>
        </div>
      </section>
    </EditablePageShell>
  );
}
